// Slick Slider
$(document).ready(function(){

  // Header Slider
	$('.cup-header-slider').each(function () {
  	var slider = $(this);
  	slider.slick({
      arrows: false,
      dots: true,
      //speed: 300,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 3500,
      slidesToShow: 1,
      appendDots: slider.parent().find('.cup-header-slider-nav'),
  	});
	});  
    
});


// WEBPACK FOOTER //
// ./js/parts/cup-oz.js